import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1405Component } from './kymw1405.component';


/**
 * 掲載候補商品リスト画面 モジュール設定クラス
 *
 * @export KYMW1405Module
 * @class KYMW1405Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1405Component,
  ],
  providers: [
  ],
})
export class KYMW1405Module {
}
